import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from 'chameleon/ui-stack/ui/base/button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import Icon from 'chameleon/ui-stack/ui/base/icon';

const DropdownButton = forwardRef((props, ref) => {
  const {
    children,
    className,
    containerClassName,
    icon,
    iconClassName,
    iconWidth,
    iconHeight,
    ...otherProps
  } = props;

  let buttonProps = {
    ref,
    className: cn('flex items-center', className),
    ...otherProps,
  };

  const buttonContent = (
    <div className="flex items-center space-x-2.5">
      <div>{children}</div>
      <Icon id="dropdown_icon_down" accessibility={{}} />
    </div>
  );

  if (icon) {
    return (
      <ButtonWithIcon
        icon={icon}
        iconWidth={iconWidth}
        iconHeight={iconHeight}
        iconClassName={iconClassName}
        containerClassName={containerClassName}
        {...buttonProps}
      >
        {buttonContent}
      </ButtonWithIcon>
    );
  }

  return <Button {...buttonProps}>{buttonContent}</Button>;
});

DropdownButton.propTypes = {
  children: PropTypes.node.isRequired,
  containerClassName: PropTypes.string,
  icon: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  iconWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DropdownButton.defaultProps = {
  containerClassName: '',
  iconClassName: '',
  iconWidth: null,
  iconHeight: null,
};

export default DropdownButton;
